import styled from "styled-components";

export default styled.div`
  width: 100%;

  .simple-header-component {
    background-color: rgba(218, 218, 218, 0.5);
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
    border-radius: 12px 12px 0 0;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    padding: 0.5rem 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem;

    .arrow-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .simple-header-component-info {
      display: flex;
      align-items: center;
      gap: 1rem;
    }

    &--with-arrow {
      justify-content: flex-start;
    }
  }

  @media screen and (max-width: 768px) {
    width: 100%;

    .simple-header-component {
      border-radius: 0px 0px 0px 0px;
      display: flex;
      gap: 0.5rem;
      padding-left: 1rem;

      .back-arrow {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .simple-header-component-info {
      }
    }
  }
`;
